import React, { useMemo } from 'react'
import { toJS } from 'mobx'
import { types } from 'mobx-state-tree'
import { Address as Model, editableModel } from '@linqpal/models'
import { useEditorModel } from '../../useEditorModel'
import { useTranslation } from 'react-i18next'
import { AddressEditor } from './AddressEditor'

const AddressStore = types.compose(Model, editableModel()).named('AddressStore')

function validate(value: any | null) {
  return !!value?.allFilled
}

export function Address(props) {
  const { doc, group, item, onValueUpdate, testID, review } = props
  const { t } = useTranslation('application')

  const model = useEditorModel(
    doc,
    group,
    item,
    onValueUpdate,
    null,
    validate,
    Model,
  )

  const address = useMemo(() => {
    return model.value
      ? AddressStore.create(toJS(model.value))
      : AddressStore.create({})
  }, [model.value])

  const updateModel = () => {
    model.setValue('address', address)
  }

  return (
    <AddressEditor
      model={address}
      label={t('Business.StreetAddressLabel')}
      testID={testID}
      review={review}
      onModelUpdate={updateModel}
    />
  )
}
